









import { Component, Vue } from "vue-property-decorator";

import { FJ_ENV, FjEnv, OTHER_INFO } from "@/consts/const";
import LanguageSelectBox from "@/components/common/selectbox/LanguageSelectBox.vue";

@Component({
  components: {
    LanguageSelectBox,
  },
})
export default class GlobalHeader extends Vue {
  private get headerClass(): { [key: string]: boolean } {
    return {
      "header--fj-dev": FJ_ENV === FjEnv.Dev,
      "header--fj-stg": FJ_ENV === FjEnv.Stg,
    };
  }

  private onClickLogo(): void {
    window.location.href = OTHER_INFO.FUJITSU_SITE_URL;
  }
}
